import { useState, useEffect } from 'react';
import './department.css';
import plus from '../../assets/icons/Plus.png';
import frame from '../../assets/icons/Frame.png';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import departmentsService from '../../services/departmentsService';
import {
    DragDropContext,
    Droppable,
    Draggable,
    resetServerContext,
} from 'react-beautiful-dnd';
import CreateDepartmentDialog from './create';
import EditDepartmentDialog from './edit';
import DeleteDepartmentDialog from './delete';
import { RootState } from 'store';
import { useSelector } from 'react-redux';
import { isAllowAction } from 'utils/helper/workerHelper';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#C7DCF5',
        color: '#1C1E21',
        paddingTop: '8px',
        paddingBottom: '8px',
        fontWeight: 600,
    },
    [`&.${tableCellClasses.body}`]: {
        fontFamily: 'Zen Kaku Gothic Antique',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '24px',
        color: '#1C1E21',
        padding: '4px 16px',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Department = (props) => {
    const { userData } = useSelector((state: RootState) => state.users);
    const isAllow = isAllowAction(userData);

    const [openCreate, setOpenCreate] = useState<boolean>(false);
    const [openEdit, setOpenEdit] = useState<boolean>(false);
    const [openDelete, setOpenDelete] = useState<boolean>(false);
    const [departmentsList, setDepartmentsList] = useState<any>([]);
    const [selectedDepartment, setSelectedDepartment] = useState<any>(null);

    const [isChangeDepartment, setChangeDepartment] = useState(false);

    const getListDepartment = async () => {
        try {
            const response = await departmentsService.getListDepartments();
            if (response !== null && response !== undefined) {
                setDepartmentsList(response.departments);
                resetServerContext();
            }
        } catch (err) {
            console.log('err', err);
        }
    };

    const handleDrop = async (droppedItem) => {
        if (!droppedItem.destination || !isAllow) return;
        var updatedList = [...departmentsList];
        const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
        // console.log(reorderedItem)
        updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
        setDepartmentsList(updatedList);
        let body = [
            {
                id: reorderedItem.id,
                sort_index:
                    departmentsList[updatedList.indexOf(reorderedItem)]
                        .sort_index,
            },
            {
                id: departmentsList[updatedList.indexOf(reorderedItem)].id,
                sort_index: reorderedItem.sort_index,
            },
        ];
        try {
            const response = await departmentsService.reorderDepartments({
                departments: body,
            });
            if (response !== null && response !== undefined) {
                setChangeDepartment((prevState) => !prevState);
            }
        } catch (err) {
            console.log('err', err);
        }
    };

    useEffect(() => {
        getListDepartment();
    }, [isChangeDepartment]);

    useEffect(() => {
        if (!openEdit) {
            setSelectedDepartment(null);
        }
    }, [openEdit]);

    useEffect(() => {
        if (!openDelete) {
            setSelectedDepartment(null);
        }
    }, [openDelete]);

    return (
        <>
            {openCreate && (
                <CreateDepartmentDialog
                    open={openCreate}
                    setOpen={setOpenCreate}
                    onFinish={() => {
                        getListDepartment();
                        setOpenCreate(false);
                    }}
                />
            )}
            {openEdit && selectedDepartment && (
                <EditDepartmentDialog
                    open={openEdit}
                    setOpen={setOpenEdit}
                    onFinish={() => {
                        getListDepartment();
                        setOpenEdit(false);
                    }}
                    selectedDepartment={selectedDepartment}
                    isAllow={isAllow}
                />
            )}
            {openDelete && selectedDepartment && (
                <DeleteDepartmentDialog
                    open={openDelete}
                    setOpen={setOpenDelete}
                    onFinish={() => {
                        getListDepartment();
                        setOpenDelete(false);
                    }}
                    selectedDepartment={selectedDepartment}
                />
            )}
            <div className="container-department d-flex flex-row">
                <div className="department-content d-flex flex-column">
                    <div
                        className="create-button d-flex flex-row"
                        style={{ height: '73px' }}
                    >
                        {isAllow && 
                            <button
                                className="create-user-button d-flex flex-row"
                                onClick={() => setOpenCreate(true)}
                            >
                                <img
                                    width={'16px'}
                                    height={'16px'}
                                    src={plus}
                                ></img>
                                新規作成
                            </button>
                        }
                    </div>
                    <div className="table-departments d-flex flex-column">
                        <div
                            className="table-content d-flex flex-column"
                            style={{}}
                        >
                            <TableContainer component={Paper}>
                                <Table
                                    sx={{ minWidth: 700 }}
                                    aria-label="customized table"
                                >
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell
                                                className="text-overflow"
                                                align="center"
                                                style={{ width: '5%' }}
                                            ></StyledTableCell>
                                            <StyledTableCell
                                                className="text-overflow"
                                                align="center"
                                                style={{ width: '70%' }}
                                            >
                                                部署名
                                            </StyledTableCell>
                                            <StyledTableCell
                                                className="text-overflow"
                                                align="center"
                                                style={{ width: '25%' }}
                                            >
                                                操作
                                            </StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <DragDropContext onDragEnd={handleDrop}>
                                        <Droppable droppableId="list-container">
                                            {(provided) => (
                                                <TableBody
                                                    {...provided.droppableProps}
                                                    ref={provided.innerRef}
                                                >
                                                    {departmentsList !== null &&
                                                        departmentsList.map(
                                                            (row, ind) => (
                                                                <Draggable
                                                                    key={row.id}
                                                                    draggableId={
                                                                        row.name
                                                                    }
                                                                    index={ind}
                                                                    isDragDisabled={isAllow ? false : true}
                                                                >
                                                                    {(
                                                                        provided,
                                                                    ) => (
                                                                        <StyledTableRow
                                                                            ref={
                                                                                provided.innerRef
                                                                            }
                                                                            {...provided.dragHandleProps}
                                                                            {...provided.draggableProps}
                                                                        >
                                                                            <StyledTableCell
                                                                                className="text-overflow"
                                                                                align="left"
                                                                                component="th"
                                                                                scope="row"
                                                                            >
                                                                                <img
                                                                                    width={
                                                                                        '20px'
                                                                                    }
                                                                                    height={
                                                                                        '20px'
                                                                                    }
                                                                                    src={
                                                                                        frame
                                                                                    }
                                                                                ></img>
                                                                            </StyledTableCell>
                                                                            <StyledTableCell
                                                                                className="text-overflow"
                                                                                align="left"
                                                                                component="th"
                                                                                scope="row"
                                                                            >
                                                                                <div className="department-row">
                                                                                    {
                                                                                        row.name
                                                                                    }
                                                                                </div>
                                                                            </StyledTableCell>

                                                                            <StyledTableCell
                                                                                className="text-overflow"
                                                                                align="center"
                                                                            >
                                                                                {isAllow && 
                                                                                    <button
                                                                                        className="button-tb"
                                                                                        style={{
                                                                                            width: '72px',
                                                                                            margin: '5px',
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            setSelectedDepartment(
                                                                                                row,
                                                                                            );
                                                                                            setOpenEdit(
                                                                                                true,
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        編集
                                                                                    </button>
                                                                                }
                                                                                {isAllow &&
                                                                                    <button
                                                                                        className="button-tb"
                                                                                        style={{
                                                                                            width: '72px',
                                                                                            margin: '5px',
                                                                                            background:
                                                                                                '#FF5045',
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            setOpenDelete(
                                                                                                true,
                                                                                            );
                                                                                            setSelectedDepartment(
                                                                                                row,
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        削除
                                                                                    </button>
                                                                                }
                                                                            </StyledTableCell>
                                                                        </StyledTableRow>
                                                                    )}
                                                                </Draggable>
                                                            ),
                                                        )}
                                                </TableBody>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Department;
